import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';

export type SpinnerSize = 'xs' | 'sm' | 'md' | 'lg';

@Component({
    selector: 'pvp-spinner',
    imports: [CommonModule],
    changeDetection: ChangeDetectionStrategy.OnPush,
    template: `
    <span
      [attr.role]="decorative() ? null : 'status'"
      [attr.aria-label]="decorative() ? null : label()"
      [attr.aria-hidden]="decorative() ? 'true' : null"
      [class]="spinnerClass()"
    >
      @if (!decorative()) {
        <span class="sr-only">{{ label() }}</span>
      }
    </span>
  `
})
export class SpinnerComponent {
  readonly size  = input<SpinnerSize>('md');
  readonly label = input('Cargando...');
  readonly color = input('text-primary');
  /**
   * Spinner PURAMENTE VISUAL: sin rol, sin nombre y oculto al lector de pantalla.
   *
   * Necesario cuando el spinner vive DENTRO de un control que ya tiene su propio
   * rol y nombre — un botón, por ejemplo. Si no, pasan dos cosas malas: queda un
   * `role="status"` anidado dentro del `role=button`, y el texto sr-only se suma
   * al NOMBRE ACCESIBLE del botón ("Cargando... Confirmar cancelación"). El estado
   * de carga lo comunica el `aria-busy` del control que lo contiene, y el
   * resultado de la operación lo anuncian los toasts.
   */
  readonly decorative = input(false);

  protected spinnerClass(): string {
    const sizes: Record<SpinnerSize, string> = {
      xs: 'h-3 w-3 border',
      sm: 'h-4 w-4 border-2',
      md: 'h-6 w-6 border-2',
      lg: 'h-8 w-8 border-[3px]',
    };
    return [
      'inline-block animate-spin rounded-full border-solid border-current border-r-transparent',
      sizes[this.size()],
      this.color(),
    ].join(' ');
  }
}
